// Exact TheMacroBar wordmark: bold "The" + serif-italic "Macro" + bold "Bar."
// Uses currentColor so it adapts to light/dark backgrounds.
export const Logo = ({ className = "" }) => (
  <span className={`font-display tracking-tight leading-none whitespace-nowrap ${className}`}>
    <span className="font-extrabold">The</span>
    <span className="logo-serif font-semibold">Macro</span>
    <span className="font-extrabold">Bar.</span>
  </span>
);
